import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';

import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';
import CommentEditor from 'ui/Mention/CommentEditor';

const StyPaper = styled(Paper, {
    name: 'StyPaper',
})({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
});

type Props = {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    sendComment: FlowAnyFunction;
    disableButton: boolean;
    canEdit?: boolean;
    children?: React.ReactNode;
    // cancel is only used when isUpdate is true
    isUpdate?: boolean;
    cancel?: FlowAnyFunction;
};

const StyButton = styled(Button, {
    name: 'StyButton',
})({
    width: '100%',
    height: '26px',
    minHeight: '26px',
    marginTop: '0.5rem',
});

const EMPTY_HTML_COMMENT = '<p></p>';

function CommentTextField({
    value,
    setValue,
    sendComment,
    disableButton,
    isUpdate = false,
    cancel = undefined,
    canEdit = false,
    children = undefined,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [shouldReset, setShouldReset] = useState(false);
    return (
        <>
            <StyPaper elevation={0} variant="outlined">
                <CommentEditor
                    isEditable={canEdit}
                    content={value}
                    setContent={setValue}
                    shouldReset={shouldReset}
                    setShouldReset={setShouldReset}
                />
                {children}
            </StyPaper>
            {canEdit && value !== EMPTY_HTML_COMMENT && (
                <>
                    <StyButton
                        variant="contained"
                        onClick={(e) => {
                            sendComment(e);
                            if (!isUpdate) {
                                setShouldReset(true);
                            }
                        }}
                        disabled={disableButton}
                    >
                        {isUpdate
                            ? t('budgetHistory.editComment')
                            : t('budgetHistory.addComment')}
                    </StyButton>
                    {isUpdate && (
                        <StyButton
                            variant="contained"
                            onClick={(e) => {
                                if (cancel) cancel(e);
                                setShouldReset(true);
                            }}
                        >
                            {t('common.cancel')}
                        </StyButton>
                    )}
                </>
            )}
        </>
    );
}

export default CommentTextField;
